import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _styled from "@emotion/styled-base";
const _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
// Emotion
import { jsx as ___EmotionJSX } from "@emotion/core";
const StdLabel = /*#__PURE__*/_styled('label', {
  target: "e1yuccfv0"
})("color:", _ref => {
  let {
    theme
  } = _ref;
  return theme.text.medium;
}, ";display:block;font-size:1rem;margin-bottom:8px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdGFuZGFyZC1maWVsZHMvYXRvbXMvTGFiZWwuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtnQyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvc3RhbmRhcmQtZmllbGRzL2F0b21zL0xhYmVsLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuLy8gRW1vdGlvblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5jb25zdCBTdGRMYWJlbCA9IHN0eWxlZCgnbGFiZWwnKWBcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudGV4dC5tZWRpdW19O1xuICBkaXNwbGF5OiBibG9jaztcbiAgZm9udC1zaXplOiAxcmVtO1xuICBtYXJnaW4tYm90dG9tOiA4cHg7XG5gO1xuXG5jb25zdCBMYWJlbCA9ICh7IGNoaWxkcmVuLCAuLi5wcm9wcyB9KSA9PiB7XG4gIHJldHVybiA8U3RkTGFiZWwgey4uLnByb3BzfT57Y2hpbGRyZW59PC9TdGRMYWJlbD47XG59O1xuXG5MYWJlbC5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxuICBodG1sRm9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG59O1xuXG5leHBvcnQgeyBMYWJlbCB9O1xuIl19 */"));
const Label = _ref2 => {
  let {
      children
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return ___EmotionJSX(StdLabel, props, children);
};
Label.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string.isRequired
};
export { Label };